import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-leave',
  templateUrl: './my-leave.component.html'
})
export class MyLeaveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/my-leave/my-leave.component.ts